// Typelizer digest 60bc6d70ff76697b17cac57e3a649ba3
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** GET /c/:company_id/ledger/vat_return/summary */
  show: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/ledger/vat_return/summary', {}, options),
    method: 'get',
  }),
}
